var Pdf = (function() {

    var _this, CONFIG;

    CONFIG = {
        PDFMAKE_URL: '/lib/pdfmake.min.js',
        IMAGES: {
            placeHolderClub: '/res/img/pdf/club.png',
            logoOverlay: '/res/img/pdf/overlay_white.png'
        },
        SVG: {
            wordmarkBG: '/res/img/logo/scoretrek_wordmark_oneline_bg.svg'
        },
        URL: {
            fonts: `https://cdn.score-trek.de/fonts/` // TODO make this configurable
        }
    };

    function urlToBase64(url) {
        return new Promise(
            function(resolve) {
                try {
                    fetch(url).then(response => {
                        if (!response.ok) {
                            console.warn(response);
                            resolve(null);
                            return;
                        }
                        return response.blob();
                    }).then(blob => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            resolve(reader.result);
                        };
                        reader.onerror = (error) => {
                            console.warn(error);
                            resolve(null);
                        };
                        reader.readAsDataURL(blob);
                    }).catch(error => {
                        console.warn(error);
                        resolve(null);
                    });
                } catch(error) {
                    console.warn(error);
                    resolve(null);
                }
            }
        );
    }

    function urlToText(url) {
        return new Promise(
            function(resolve) {
                try {
                    fetch(url).then(response => {
                        if (!response.ok) {
                            console.warn(response);
                            resolve(null);
                            return;
                        }
                        return response.text();
                    }).then(text => {
                        resolve(text);
                    }).catch(error => {
                        console.warn(error);
                        resolve(null);
                    });
                } catch(error) {
                    console.warn(error);
                    resolve(null);
                }
            }
        );
    }

	function outputPlayerName(name) {
		return (String(name).trim().toUpperCase() == 'DELETED PLAYER') ? '– '+i18nPdf('player.deleted')+' –' : name;
	}

    function outputDate(date) {
        date = String(date);
        return `${date.substr(6,4)}-${date.substr(3,2)}-${date.substr(0,2)}_${date.substr(11,2)}-${date.substr(14,2)}`;
    }

    function floatToString(number, precision, separator, roundingFunc) {
        return Numbers.floatToString(number, precision, separator, roundingFunc);
    }

    function i18nPdf(key) {
        var translations;
        translations = {
            'player': 'Spieler',
            'break.highest.short': 'HB',
            'points': 'Punkte',
            'breaks.short': 'Aufn.',
            'average.short': 'GD',
            'break': 'Aufnahme',
            'balls': 'Bälle',
            'date': 'Datum',
            'break.limit.short': 'Max. Aufn.',
            'target': 'Ausspielziel',
            'game.report': 'Spielbericht',
            'page': 'Seite',
            'of': 'von'
        };
        return translations.hasOwnProperty(key) ? translations[key] : key;
    }

	function renderTextPDF(text, options) {
		var textParts, stack, specialChars;

		specialChars = {
			'₂': {text: '2', style: {fontSize: 8}} ,
			'₃': {text: '3', style: {fontSize: 8}},
			'/': {text: ' / '},
			',': {text: ',\u200b'}
		};

		options = $.extend({
			svg: false
		}, options);
		stack = [];

		if (!options.svg) {
			textParts = String(text).split(' ').join('').split('');
			$.each(textParts, function(index, textPart) {
				if (specialChars.hasOwnProperty(textPart)) {
					stack.push(specialChars[textPart]);
				} else {
					stack.push({text: textPart});
				}
			});
		}

		return stack;
	}

    function render(history) {
        return new Promise(function(resolve, reject) {
            Promise.all([
                urlToBase64(history.meta.clubLogo),
                urlToBase64(CONFIG.IMAGES.placeHolderClub),
                urlToBase64(CONFIG.IMAGES.logoOverlay),
                urlToText(CONFIG.SVG.wordmarkBG)
            ]).then(
                function(images) {
                    loadPdfMake().then(() => {
                        generateHistory(history, {
                            logo: images[0] ? images[0] : images[1],
                            logoOverlay: images[2],
                            wordmarkBG: images[3]
                        }).then(resolve).catch(reject);
                    }).catch(reject);
                }
            ).catch(reject);
        });
    }

    function loadPdfMake() {
        return new Promise(function(resolve, reject) {
            let script;
            
            if (window.pdfMake) {
                resolve();
                return;
            }

            script = document.createElement('script');
            script.src = `${CONFIG.PDFMAKE_URL}?${ScoreTrekBattle.ENV.BUILD}`;
            script.addEventListener('error', function() {
                reject(new Error('PDF_MAKE_LOAD_FAILED'));
            });
            script.addEventListener('load', function() {
               resolve();
            });
            document.querySelector('head').appendChild(script);
        });
    }

    function generateHistory(history, assets) {
        return new Promise(function(resolve, reject) {
            var docDefinition, rows, i, headerDetails, pdfFileName;
            let hasHandicap;

            try {
                pdfMake.fonts = {
                    'Nunito': {
                        'normal': `${CONFIG.URL.fonts}nunito-v12/nunito-v12-latin_latin-ext-regular.ttf`,
                        'bold': `${CONFIG.URL.fonts}nunito-v12/nunito-v12-latin_latin-ext-700.ttf`,
                        'italics': `${CONFIG.URL.fonts}nunito-v12/nunito-v12-latin_latin-ext-italic.ttf`,
                        'bolditalics': `${CONFIG.URL.fonts}nunito-v12/nunito-v12-latin_latin-ext-700italic.ttf`
                    },
                    'Patrick Hand SC': {
                        'normal': `${CONFIG.URL.fonts}patrick-hand-sc-v8/patrick-hand-sc-v8-latin-regular.ttf`
                    }
                };

                history.meta.average1 = ((history.meta.result1 > 0) && (history.meta.breaks1 > 0)) ? (history.meta.result1 / history.meta.breaks1) : 0;
                history.meta.average2 = ((history.meta.result2 > 0) && (history.meta.breaks2 > 0)) ? (history.meta.result2 / history.meta.breaks2) : 0;

                hasHandicap = history.data.balls && history.data.balls[0] && (history.data.balls[0][0] === 'Handicap');

                rows = [
                    [
                        {text: i18nPdf('player'), style: {alignment: 'right'}, margin: [0, 6, 0, 0]},
                        {text: outputPlayerName(history.players[0]), colSpan: 4, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'center', color: '#0066ff'}},
                        {},
                        {},
                        {},
                        {text: outputPlayerName(history.players[1]), colSpan: 4, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'center', color: '#0066ff'}},
                        {},
                        {},
                        {}
                    ]
                ];

                if (history.meta.gameType == 'gameSnooker') {
                    rows.push([
                        {},
                        {text: i18nPdf('break.highest.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.maximum1, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('points')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.result1, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('break.highest.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.maximum2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('points')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.result2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]}
                    ]);
                } else {
                    rows.push([
                        {},
                        {text: i18nPdf('points')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.result1, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('breaks.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.breaks1, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('points')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.result2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('breaks.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.breaks2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]}
                    ]);
                    rows.push([
                        {},
                        {text: i18nPdf('break.highest.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.maximum1, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('average.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: floatToString(history.meta.average1, 2), style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('break.highest.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: history.meta.maximum2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]},
                        {text: i18nPdf('average.short')+':', style: {fontSize: 12, alignment: 'right'}, margin: [0, 6, 0, 0], border: [true, true, false, true]},
                        {text: floatToString(history.meta.average2, 2), style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'left', color: '#0066ff'}, margin: [0, 0, 0, 0], border: [false, true, true, true]}
                    ]);
                }
                rows.push([
                    {text: i18nPdf('break'), style: {alignment: 'right'}},
                    {text: i18nPdf('balls'), colSpan: 2, style: {alignment: 'center'}},
                    {},
                    {text: i18nPdf('points'), colSpan: 2, style: {alignment: 'center'}},
                    {},
                    {text: i18nPdf('balls'), colSpan: 2, style: {alignment: 'center'}},
                    {},
                    {text: i18nPdf('points'), colSpan: 2, style: {alignment: 'center'}},
                    {}
                ]);

                for (i = 0; i < history.data.balls.length; i++) {
                    rows.push([
                        {text: String(i+(hasHandicap ? 0 : 1)).concat('.'), style: {fontSize: 18, alignment: 'right'}},
                        {text: renderTextPDF(history.data.balls[i][0]), colSpan: 2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: (history.meta.gameType == 'gameSnooker') ? 'left' : 'center', color: '#0066ff'}},
                        {},
                        {text: renderTextPDF(history.data.points[i][0]), colSpan: 2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'center', color: '#0066ff'}},
                        {},
                        {text: renderTextPDF(history.data.balls[i][1]), colSpan: 2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment:  (history.meta.gameType == 'gameSnooker') ? 'left' : 'center', color: '#0066ff'}},
                        {},
                        {text: renderTextPDF(history.data.points[i][1]), colSpan: 2, style: {font: 'Patrick Hand SC', fontSize: 18, alignment: 'center', color: '#0066ff'}},
                        {}
                    ]);
                }

                headerDetails = [];

                headerDetails.push([
                    {
                        border: [false,false,false,false],
                        text: i18nPdf('date')+':',
                        style: {alignment: 'right'},
                        margin: [0, 6, 0, 0]
                    },
                    {
                        border: [false,false,false,false],
                        text: history.meta.date,
                        style: {alignment: 'right', font: 'Patrick Hand SC', fontSize: 18, color: '#0066ff'}
                    }
                ]);
                
                if (history.meta.breakLimit > 0) {
                    headerDetails.push([
                        {
                            border: [false,false,false,false],
                            text: i18nPdf('break.limit.short')+':',
                            style: {alignment: 'right'},
                            margin: [0, 16, 0, 0]
                        },
                        {
                            border: [false,false,false,false],
                            text: history.meta.breakLimit,
                            style: {alignment: 'center', font: 'Patrick Hand SC', fontSize: 18, color: '#0066ff'},
                            margin: [0, 10, 0, 0]
                        }
                    ]);
                } else {
                    headerDetails.push([
                        {
                            border: [false,false,false,false],
                            text: ''
                        },
                        {
                            border: [false,false,false,false],
                            text: '',
                        }
                    ]);
                }

                if (history.meta.gameType != 'gameSnooker') {
                    headerDetails.push([
                        {
                            border: [false,false,false,false],
                            text: i18nPdf('target')+':',
                            style: {alignment: 'right'},
                            margin: [0, 16, 0, 0]
                        },
                        {
                            border: [false,false,false,false],
                            text: history.meta.target,
                            style: {alignment: 'center', font: 'Patrick Hand SC', fontSize: 18, color: '#0066ff'},
                            margin: [0, 10, 0, 0]
                        }
                    ]);
                }

                if (history.meta.breakLimit == 0) {
                    headerDetails.push([
                        {
                            border: [false,false,false,false],
                            text: ''
                        },
                        {
                            border: [false,false,false,false],
                            text: '',
                        }
                    ]);
                }

                docDefinition = {
                    info: {
                        title: `${history.meta.gameShortTitle} - ${i18nPdf('game.report')}`,
                        author: history.meta.clubName,
                        subject: outputPlayerName(history.players[0])+' - VS - '+outputPlayerName(history.players[1]),
                        keywords: '',
                        creator: 'Score Trek',
                        producer: 'chm-software.com',
                        creationDate: history.meta.date,
                        modDate: history.meta.date
                    },
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    pageMargins: [40, 40, 40, 50],
                    defaultStyle: {
                        font: 'Nunito',
                        fontSize: 12
                    },
                    images: {
                        overlay: assets.logoOverlay,
                        logo: assets.logo
                    },
                    footer: function(currentPage, pageCount) {
                        return {
                            columns: [
                                {
                                    border: [false,false,false,false],
                                    svg: assets.wordmarkBG,
                                    width: 81,
                                    height: 15,
                                    margin: [40, 10, 0, 0]
                                },
                                {
                                    text: `${i18nPdf('page')} ${String(currentPage)} ${i18nPdf('of')} ${String(pageCount)}`,
                                    style: {fontSize: 10, alignment: 'right'},
                                    margin: [0, 10, 40, 0]
                                }
                            ]
                        };
                    },
                    content: [
                        {
                            table: {
                                widths: [75,'*','auto'],
                                heights: [75],
                                headerRows: 0,
                                body: [
                                    [
                                        {
                                            border: [false,false,false,false],
                                            stack: [
                                                {
                                                    image: 'logo',
                                                    width: 75,
                                                    height: 75,
                                                    absolutePosition: {x: 44, y: 43}
                                                },
                                                {
                                                    border: [false,false,false,false],
                                                    image: 'overlay',
                                                    width: 75,
                                                    height: 75,
                                                    absolutePosition: {x: 44, y: 43}
                                                }
                                            ]
                                        },
                                        {
                                            border: [false,false,false,false],
                                            table: {
                                                widths: ['auto'],
                                                body: [
                                                    [
                                                        {
                                                            border: [false,false,false,false],
                                                            text: history.meta.clubName,
                                                            style: {alignment: 'left', fontSize: 16, bold: true},
                                                            margin: [10, 2, 0, 0]
                                                        }
                                                    ],
                                                    [
                                                        {
                                                            border: [false,false,false,false],
                                                            text: history.meta.gameTitle,
                                                            style: {alignment: 'left', fontSize: 24, bold: true},
                                                            margin: [10, 10, 0, 0]
                                                        }
                                                    ]
                                                ]
                                            },


                                        },
                                        {
                                            border: [false,false,false,false],
                                            table: {
                                                widths: ['auto', 'auto'],
                                                body: headerDetails
                                            },
                                            style: {
                                                alignment: 'right'
                                            }
                                        }
                                    ]
                                ]
                            }
                        },
                        {
                            text: ' '
                        },
                        {
                            table: {
                                widths: ['auto','*','*','*','*','*','*','*','*'],
                                headerRows: (history.meta.gameType == 'gameSnooker') ? 3 : 4,
                                body: rows
                            },
                            layout: {
                                hLineWidth: function (row, node) {
                                    return 1;
                                },
                                vLineWidth: function (col, node) {
                                    return 1;
                                },
                                hLineColor: function (row, node, col) {
                                    if (row == 1) {
                                        return '#ccc';
                                    } else if ((history.meta.gameType != 'gameSnooker') && (row == 2)) {
                                        return '#fff';
                                    }
                                    return '#000';												
                                },
                                vLineColor: function (col, node, row) {
                                    if ((row == 1) || ((history.meta.gameType != 'gameSnooker') && (row == 2))) {
                                        if ((col == 3) || (col == 7)) {
                                            return '#ccc';
                                        }
                                    }
                                    return '#000';												
                                }
                            }
                        }
                    ]
                };

                pdfFileName = `${outputDate(history.meta.date)} ${i18nPdf('game.report')} - ${history.meta.gameShortTitle}`;
                pdfMake.createPdf(docDefinition).getBase64().then(pdfBase64 => {
                    resolve({
                        fileBase64: pdfBase64,
                        fileName: pdfFileName
                    });
                }).catch(reject);
            } catch(error) {
                reject(error);
            }
        });
    }

    _this = {
        generateHistory: function(history) {
            return render(history);
        },
        showError: function() {
            chmDialog.error('error/FILE_GENERATION_FAILED');
        }
    };

    return _this;

})();
